import React from "react";
import Arrow from "./icons/Arrow";
import Chevron from "./icons/Chevron";
import Exclamation from "./icons/Exclamation";
import LittleArrow from "./icons/LittleArrow";
import Triangle from "./icons/Triangle";
var Icon = function (props) {
    switch (props.kind) {
        case "Triangle":
            return (React.createElement(Triangle, { color: props.color, direction: props.direction, className: props.className }));
        case "LittleArrow":
            return React.createElement(LittleArrow, { color: props.color, className: props.className });
        case "Arrow":
            return React.createElement(Arrow, { color: props.color, className: props.className });
        case "Chevron":
            return (React.createElement(Chevron, { color: props.color, direction: props.direction, className: props.className }));
        case "Exclamation":
            return React.createElement(Exclamation, { color: props.color, className: props.className });
    }
};
export default Icon;
